import SvietimasService from '@/common/services/svietimas.service';
import {
    GET_SVIETIMAS_CHILDREN, SET_SVIETIMAS_CHILDREN,
    GET_SVIETIMAS_COURSES, SET_SVIETIMAS_COURSES,
    RESET_SVIETIMAS_STATE,
    SET_SVIETIMAS_ERROR
} from '@/store/modules/svietimas/actions';

const getDefaultState = () => {
    return {
        courses: [],
        error_message: null,
        children: []
    };
};

const state = getDefaultState();
const mutations = {
    [RESET_SVIETIMAS_STATE](){
        Object.assign(state, getDefaultState());
    },
    [SET_SVIETIMAS_COURSES](state, courses) {
        state.courses = courses;
    },
    [SET_SVIETIMAS_CHILDREN](state, children) {
        state.children = children;

    },
    [SET_SVIETIMAS_ERROR](state, message) {
        state.error_message = message;
    }
};
const actions = {
    [GET_SVIETIMAS_COURSES]({commit, getters}, options) {
        commit(RESET_SVIETIMAS_STATE);
        return SvietimasService.getClasses(getters.activeKindergartenId, options).then(res => {
            if(res.error) {
                commit(SET_SVIETIMAS_ERROR, res.message);
            } else {
                commit(SET_SVIETIMAS_COURSES, res.data);
            }
        });
    },
    [GET_SVIETIMAS_CHILDREN]({commit, getters}, options) {
        commit(SET_SVIETIMAS_ERROR, null);
        return SvietimasService.getChildren(getters.activeKindergartenId, options).then(res => {
            if(res.error) {
                commit(SET_SVIETIMAS_ERROR, res.message);
            } else {
                commit(SET_SVIETIMAS_CHILDREN, res.data);
            }

        });
    }
};
const getters = {
    svietimasClasses: state => state.courses,
    svietimasError: state => state.error_message,
    svietimasClassChildren: state => state.children
};
export default {
    state,
    mutations,
    actions,
    getters
};
